import { Button } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { COPY_BUTTON_ACTION } from "../../../consts/sentryIds";
import { View } from "../../View";
import { palette } from "../../../theme/palette";

const useStyles = makeStyles({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    padding: "16px",
  },
  blue: {
    background: palette.btn.blueFill,
    color: palette.typography.white.high,
    border: palette.btn.blueBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.blueFill,
    },
  },
});

export const CopyActions = ({ copyDisabled, onCopy }) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <Button
        className={styles.blue}
        variant={"contained"}
        disabled={copyDisabled}
        onClick={onCopy}
        sentryId={COPY_BUTTON_ACTION}
      >
        Copy
      </Button>
    </View>
  );
};
